// Data från API:t som flera sidor använder, med TanStack Query (ADR 0062).
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/auth.js';
import { data } from './client.js';

export const nycklar = {
  startmallar: ['startmallar'] as const,
  prismodeller: ['prismodeller'] as const,
  betalning: ['betalning'] as const,
};

/** Startmallarna för tjänstekatalogen. */
export function useStartmallar() {
  const { api } = useAuth();
  return useQuery({
    queryKey: nycklar.startmallar,
    queryFn: async () => data(await api.GET('/v1/admin/price-templates')).items,
    staleTime: Infinity,
  });
}

/** Byråns versioner av tjänstekatalogen, nyast först. Första sidan räcker för att se om det finns någon. */
export function usePrismodeller() {
  const { api } = useAuth();
  return useQuery({
    queryKey: nycklar.prismodeller,
    queryFn: async () => data(await api.GET('/v1/admin/pricing-models')).items,
  });
}

/**
 * Byråns plan och om kortbetalningen är öppen (ADR 0117). Med vantaPaBetalning
 * frågar den igen varannan sekund tills Stripe har bekräftat betalningen.
 */
export function useBetalning({ vantaPaBetalning = false } = {}) {
  const { api } = useAuth();
  return useQuery({
    queryKey: nycklar.betalning,
    queryFn: async () => data(await api.GET('/v1/admin/billing')),
    retry: false,
    refetchInterval: (q) =>
      vantaPaBetalning && !q.state.data?.subscription?.paid && q.state.dataUpdateCount < 30
        ? 2000
        : false,
  });
}
